import React, { useEffect, useState } from 'react';

import { ChevronIcon } from '../../icons';
import { Button } from '../index';

import './ScrollToTopButton.scoped.scss';

//TODO: REWORK TO INTERSECTION OBSERVER
const ScrollToTopButton = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', scrollCallback);
    return () => {
      window.removeEventListener('scroll', scrollCallback);
    };
  }, []);

  const scrollCallback = () => {
    setShow(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <>
      {show && (
        <Button onClick={scrollToTop} className="scroll-top-button">
          <ChevronIcon
            direction="down"
            className="scroll-top-button__arrow"
            title="Scroll to top"
          />
        </Button>
      )}
    </>
  );
};

export default ScrollToTopButton;
